(function($, undefined) {
	'use strict';

	var init = function() {
		checkForActiveCountUps();

		$(window).scroll(checkForActiveCountUps);
		$(window).resize(checkForActiveCountUps);
	};

	function countUp(countUpElement) {
		countUpElement.addClass("count-up_active");

		countUpElement.prop('Counter',0).animate({
	        Counter: countUpElement.attr('data-number')
	    }, {
	        duration: 4000,
	        easing: 'swing',
	        step: function (now) {
	        	var newValue = countUpElement.hasClass("count-up_float") ? Math.ceil(now*100)/100 : Math.ceil(now);
				countUpElement.text(newValue);
	        }
		});	
	}

	function checkForActiveCountUps() {
		var notActiveCountUps = $('.count-up:not(.count-up_active)');

		notActiveCountUps.each((i, el) => {
			if ($(el).offset().top + $(el).outerHeight() <= $(window).scrollTop() + $(window).height() && 
				$(el).offset().top >= $(window).scrollTop()) {
				countUp($(el));
			}
		});
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
